/* eslint-disable @next/next/no-img-element */

import { FC } from 'react';
import { MoveUpRight } from 'lucide-react';

import { PinContainer } from '../ui/3d-pin';
import { RecentProjectCardType } from './types/recent-project';

interface RecentProjectCardProps {
  item: RecentProjectCardType;
}

export const RecentProjectCard: FC<RecentProjectCardProps> = ({ item }) => {
  return (
    <div className="lg:min-h-[32.5rem] h-[25rem] flex items-center justify-center sm:w-[570px] w-[80vw]">
      <PinContainer title={item.repositoryLink} href={item.repositoryLink} titleFallback="Source code not available">
        <div className="relative flex items-center justify-center sm:w-[570px] w-[80vw] overflow-hidden h-[20vh] lg:h-[16rem] mb-10">
          <div className="relative w-full h-full overflow-hidden rounded-3xl bg-[#13162b]">
            <img src="/bg.png" alt="" />
          </div>
          <img src={item.img} alt={item.title} className="z-10 absolute rotate-2 -bottom-2 w-[90%] rounded-lg" />
        </div>
        <h1 className="font-bold lg:text-2xl md:text-xl text-base line-clamp-1">
          {item.title}
        </h1>
        <p className="lg:text-xl lg:font-normal font-light text-sm line-clamp-5">
          {item.description}
        </p>
        <div className="flex items-center justify-between mt-7 mb-3">
          <div className="flex items-center">
            {item.iconList.map((Icon, index) => {
              return (
                <div
                  key={index}
                  className="relative border border-white/[0.2] rounded-full bg-black lg:size-10 size-8 flex justify-center items-center transition duration-200 hover:z-10 hover:-translate-y-1 hover:border-purple/50"
                  style={{ marginLeft: index === 0 ? 0 : '-10px' }}
                >
                  <Icon />
                </div>
              );
            })}
          </div>
          {item.liveAppLink ? (
            <a
              href={item.liveAppLink}
              target="_blank"
              rel="noopener noreferrer"
              className="group/live inline-flex items-center rounded-md outline-offset-4 focus-visible:outline-2 focus-visible:outline-purple"
            >
              <p className="flex lg:text-lg md:text-base text-xs text-purple transition-colors duration-200 group-hover/live:text-white">
                Check Live Site
              </p>
              <MoveUpRight className="ms-3 text-purple transition-all duration-200 group-hover/live:text-white group-hover/live:translate-x-0.5 group-hover/live:-translate-y-0.5" />
            </a>
          ) : (
            <div className="flex justify-center items-center">
              <p className="flex lg:text-lg md:text-base text-xs text-purple">
                Live site is private.
              </p>
            </div>
          )}
        </div>
      </PinContainer>
    </div>
  );
};
